export default function ReviewAuthor({ label }) {
  const separator = label.indexOf(',');
  const name = separator === -1 ? label : label.slice(0, separator);
  const role = separator === -1 ? '' : label.slice(separator + 1).trim();

  return (
    <figcaption>
      <b>{name}</b>
      {role && <span>{role}</span>}
    </figcaption>
  );
}
